import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { media } from '@mlb/react-patterns/style/helpers/media.ts';
import COLORS from '@mlb/react-patterns/style/universal.color';
import FONTS from '@mlb/react-patterns/style/fonts.ts';
import SkeletonPattern from '@mlb/react-patterns/components/Skeleton/skeleton.tsx';

const FONT_SIZE = {
    default: '25px',
    md: '30px',
};

const Skeleton = styled(SkeletonPattern)`
    &&& {
        min-width: 166px;
        height: ${FONT_SIZE.default};
        margin-bottom: 0;

        ${media.mdmin`
            height: ${FONT_SIZE.md};
        `}
    }
`;

const Title = styled.h1`
    margin-bottom: 0;
    line-height: 1;
    color: ${COLORS.mlbWhite};
    font-family: ${FONTS.primaryFont};
    font-weight: bold;
    font-size: ${FONT_SIZE.default};

    ${media.mdmin`
        font-size: ${FONT_SIZE.md};
    `}
`;

const PageHeading = ({
    isLoading,
    title,
}) => {

    if (isLoading) {

        return (
            <Skeleton
                isLoading
                width={'30%'}
            />
        );

    }

    return (
        <Title>
            {title}
        </Title>
    );

};

PageHeading.propTypes = {
    isLoading: PropTypes.bool,
    title: PropTypes.string,
};

PageHeading.defaultProps = {
    isLoading: false,
    title: '',
};

export default PageHeading;
